module.exports = __webpack_public_path__ + "static/img/jinkong.70efc8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serviceCenter/jinkong.png
// module id = tUO+
// module chunks = 44